import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import tableStyles from "./components/Table/styles.module.scss";
import { M as ModeType } from "./Table.js";
import { B as Button } from "./Button.js";
import { I as Icon } from "./Icon.js";
import ChevronDown from "./components/Icons/ChevronDown.js";
import ChevronUp from "./components/Icons/ChevronUp.js";
const TableExpanderCellMobile = ({
  expanded,
  onClick,
  hideDetailsText,
  showDetailsText,
  mode = ModeType.normal
}) => {
  const cellClass = classNames(tableStyles.table__cell, tableStyles["table__expander-cell-mobile"], {
    [tableStyles["table__expander-cell-mobile--expanded"]]: expanded,
    [tableStyles["table__cell--compact"]]: mode === ModeType.compact
  });
  return /* @__PURE__ */ jsx("td", { className: cellClass, children: /* @__PURE__ */ jsxs(Button, { "aria-expanded": expanded, variant: "borderless", onClick, children: [
    /* @__PURE__ */ jsx(Icon, { svgIcon: expanded ? ChevronUp : ChevronDown }),
    " ",
    expanded ? hideDetailsText : showDetailsText
  ] }) });
};
const TableRow = ({
  rowKey,
  hideDetailsText,
  showDetailsText,
  expandable,
  expanded,
  onClick,
  className,
  children,
  mode = ModeType.normal,
  ...rest
}) => {
  const tableRowClass = classNames(
    tableStyles["table-row"],
    {
      [tableStyles["table__row--expandable"]]: expandable
    },
    className
  );
  return /* @__PURE__ */ jsxs("tr", { className: tableRowClass, onClick, ...rest, children: [
    React__default.Children.map(children, (child) => React__default.isValidElement(child) && React__default.cloneElement(child, { mode })),
    expandable && /* @__PURE__ */ jsx(
      TableExpanderCellMobile,
      {
        expanded,
        onClick,
        hideDetailsText,
        showDetailsText,
        mode
      }
    )
  ] }, rowKey);
};
export {
  TableRow as T
};
//# sourceMappingURL=TableRow.js.map
